import { render, staticRenderFns } from "./DsfExamPaperAdd.vue?vue&type=template&id=51fa85bc&"
import script from "./DsfExamPaperAdd.vue?vue&type=script&lang=js&"
export * from "./DsfExamPaperAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51fa85bc')) {
      api.createRecord('51fa85bc', component.options)
    } else {
      api.reload('51fa85bc', component.options)
    }
    module.hot.accept("./DsfExamPaperAdd.vue?vue&type=template&id=51fa85bc&", function () {
      api.rerender('51fa85bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/DsfExamPaperAdd.vue"
export default component.exports